import L from 'leaflet';

import { fetchResource } from 'utils/browser';
import { COPYRIGHT_URL } from 'constants/geospatial';

/**
 * Fetches attribution objects from the attribution endpoint (currently the raw API).
 * @returns {Array} Array of attribution objects { label, alt, boxes, minLevel, maxLevel }
 */
export async function getHereTileBoxes() {
  const rawTileBoxes = await fetchResource(COPYRIGHT_URL).then(response =>
    response.json()
  );
  return rawTileBoxes.normal.map(attr => ({
    ...attr,
    boxes: attr.boxes.map(box =>
      L.latLngBounds(L.latLng(box[0], box[1]), L.latLng(box[2], box[3]))
    ),
  }));
}

function cachedGetHereTileBoxes() {
  let cache = undefined;
  return async () => {
    if (!cache) {
      cache = await getHereTileBoxes();
    }
    return cache;
  };
}

export default cachedGetHereTileBoxes();
